export * from './icons.config';
export * from './general-images.config';
